import { useEffect } from 'react';

const STYLE = {
    container : {
        width: '100%',
        backgroundColor: '#FFFFFF',
        border: '1px solid #dadce0',
        borderRadius: '12px',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        minHeight: '48px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#3c4043',
        marginBottom: '20px',
    },
    logo : {
        width: '18px',
        height: 'auto',
        marginRight: '8px'
    }
}

const GoogleLogin = (props) => {
    const GOOGLE_CLIENT_ID = '880249707501-kien4jquuhlf60djji9pgm3i0n6nqken.apps.googleusercontent.com';

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        script.onload = () => {
            window.google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: handleCredentialResponse,
            });
        };

        return () => {
            document.head.removeChild(script);
        };
    }, [GOOGLE_CLIENT_ID]);

    const handleCredentialResponse = (response) => {
        const credential = response.credential;
        props.loginSuccessCallback(credential);
    };

    const handleLogin = () => {
        if (window.google && window.google.accounts) {
            window.google.accounts.id.prompt();
        }
    };

    return (
        <button
            onClick={handleLogin}
            style={STYLE.container}
            aria-label="구글 로그인"
        >
            <svg style={STYLE.logo} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span>구글 로그인</span>
        </button>
    );
};

export default GoogleLogin;
